export default "__VITE_ASSET__84fb1c85__"